import { createSlice } from '@reduxjs/toolkit';

// duplicateReason: 'on-call' | 'stepped-down' — picks which copy the page shows.
export const singleInstanceSlice = createSlice({
  name: 'singleInstance',
  initialState: {
    uniqueId: null,
    isDuplicate: false,
    duplicateReason: null,
  },
  reducers: {
    setUniqueId: (state, action) => {
      state.uniqueId = action.payload;
    },
    setDuplicateState: (state, action) => {
      state.isDuplicate = !!action.payload?.isDuplicate;
      state.duplicateReason = action.payload?.reason ?? null;
    },
    resetSingleInstance: (state) => {
      state.uniqueId = null;
      state.isDuplicate = false;
      state.duplicateReason = null;
    },
  },
});

export const { setUniqueId, setDuplicateState, resetSingleInstance } = singleInstanceSlice.actions;

export const selectUniqueId = (state) => state.singleInstance.uniqueId;
export const selectIsDuplicate = (state) => state.singleInstance.isDuplicate;
export const selectDuplicateReason = (state) => state.singleInstance.duplicateReason;

export default singleInstanceSlice.reducer;
